import React from 'react'
import "./signup.css"
import {Link} from "react-router-dom"

function Signup() {
  return (
    <div className='signup'>
     
    <div className='signup-intro'>
      <h3>Create your Daraz Account</h3>
      <p>Already member? <Link to="/login">Login</Link> here.</p>
    </div>
    
    <div className='signup-container'>
      <div className='signup-form'>
        <label>Phone Number*</label>
        <input type="tel" placeholder="Please enter your phone number" id="phone" name="phone" pattern="[0-9]{3}-[0-9]{2}-[0-9]{3}" />

         <label>Password*</label> 
         <input type="password" placeholder="Minimum 6 character with a number and a lettter" />
        <div className='signup-cast'>
          <div className='signup-date'>
            <label>Date of Birth</label>
            <input type="date" />
          </div>
          
          <div className='signup-date'>
            <label>Gender</label>
            <select>
              <option>Select</option>
              <option>Male</option>
              <option>Female</option>
              <option>Others</option>
            </select>
          </div>
        </div>

      </div>
      <div className='signup--with'>
        <label>Full Name*</label> 
        <input type="text" placeholder="Enter your first and last name" />
        <div className='signup-checkbox'>
          <input type="checkbox" />
          <p>I'd like to receive exclusive offers and promotions via SMS</p>
        </div>
        <button className='signup-btn'>SIGNUP</button>
        <p className="signup-terms">By Clicking "SIGN UP", I agree to Daraz's <a href="/">Terms of Use</a> and <a href="/">Privacy Policy</a></p>
        <p>Or, login with</p>
        <button className='signup-ebtn'>Sign up with Email</button>
        <div className='signup-socialbtn'>
            <button className='signup-fbtn'><strong>f</strong>Facebook</button>
            <button className='signup-gbtn'><strong>G+</strong>Google</button>
        </div>
        
      </div>
    </div>

     
  </div>
  )
}

export default Signup